import { useQuery } from '@tanstack/react-query';
import { fetchContestantByCode, fetchContestantById } from '../services/contestantService';

export const useContestant = (codeOrId: string | null) => {
  return useQuery({
    queryKey: ['contestant', codeOrId],
    queryFn: async () => {
      if (!codeOrId) return null;
      
      // Si c'est un UUID (format d'ID), utiliser fetchContestantById
      if (codeOrId.includes('-')) {
        return fetchContestantById(codeOrId);
      }
      
      // Sinon, c'est probablement un code unique
      return fetchContestantByCode(codeOrId);
    },
    enabled: !!codeOrId,
  });
};
